import * as React from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store/types';
import * as S from './styles';
import InputIconField, { InputIconFieldAction, InputIconFieldState } from 'components/InputIcon';
import { ReactComponent as GoogleSpecifics } from 'common/images/icon-google-specifics.svg'
import { Loader } from 'components/Loader'
import { serviceLoading } from 'common/loaderReducer';
import { GET_DEALERINFO_API_REQUEST } from 'features/Dealers/Listings/Info/state/actionTypes';
import { POST_DEALERLM_API_REQUEST } from 'features/Dealers/Listings/Data/state/actionTypes';
import { editLiveDealerLMInfo, postDealerLMAPI } from 'features/Dealers/Listings/Data/state/actions';
import { getSyncError } from 'features/Dealers/Listings/utils';
import { getListingSyncErrors } from 'features/Dealers/Listings/state/actions';
import { getDealerListingsWithErrors } from 'features/Dealers/Listings/state/actions';

const GoogleSpecific = (props: any) => {
    const [saving, setSaving] = React.useState(false);
    const [firstLoad, setFirstLoad] = React.useState(true);
    const [editingState, setEditingState] = React.useState(InputIconFieldState.VIEW);
    const dispatch = useDispatch();

    const {
        isLoading,
        isSaving,
        live,
        listingSyncErrors,
        selectedListingId,
        selectedDealerId,
        originalLMDealerInfo
    } = useSelector((rootState: RootState) => {
        return {
            isLoading: serviceLoading(rootState, [GET_DEALERINFO_API_REQUEST]),
            isSaving: serviceLoading(rootState, [POST_DEALERLM_API_REQUEST]),
            live: rootState.dealers.listing.currentListing.data.liveDealerLMInfo,
            originalLMDealerInfo: rootState.dealers.listing.currentListing.data.dealerLMInfo,
            listingSyncErrors: rootState.dealers.listing.listings.listingSyncErrors,
            selectedListingId: rootState.dealers.listing.listings.selectedListingId,
            selectedDealerId: rootState.dealers.dealer.selectedDealer?.id,
        }
    }, shallowEqual);

    React.useEffect(() => {
        if (!firstLoad && !isSaving && selectedListingId && selectedListingId != "" && selectedDealerId) {
            setSaving(false);
            dispatch(getListingSyncErrors(selectedListingId??""));
            dispatch(getDealerListingsWithErrors(selectedDealerId??""));
        }
        setFirstLoad(false);
    }, [isSaving])

    if (isLoading || !selectedListingId || selectedListingId == "") {
        return (
                <Loader/>
        )
    } else {
        return (
            <S.SectionWrapper margin={`4px 0`} flexFlow={"column"}>
                <InputIconField
                    label={'Google Specific'}
                    state={saving ? InputIconFieldState.LOADING : editingState}
                    renderValue={renderGoogleSpecifics}
                    renderIcon={() => { return (<S.IconContainer><GoogleSpecifics /></S.IconContainer>) }}
                    showAlertIcon={getSyncError('googleSpecifics',listingSyncErrors)?true:false}
                    alertToolTip={getSyncError('googleSpecifics',listingSyncErrors)}
                    showEditErrorMessage={getSyncError('googleSpecifics',listingSyncErrors)?true:false}
                    editErrorMessage={getSyncError('googleSpecifics',listingSyncErrors)}
                    onActionClick={(action: InputIconFieldAction) => { onFieldActionClick(action) }}
                    disabled={false}
                    disableBackground={true}
                />
            </S.SectionWrapper>
        )
    }

    function onFieldActionClick(action: InputIconFieldAction) {
        switch (action) {
            case InputIconFieldAction.SAVE:
                {
                    setEditingState(InputIconFieldState.VIEW)
                    setSaving(true);
                    if (live) dispatch(postDealerLMAPI(selectedListingId ?? "", "", live))
                    break;
                }
            case InputIconFieldAction.EDIT:
                {
                    setEditingState(InputIconFieldState.EDIT)
                    break;
                }
            case InputIconFieldAction.CANCEL:
                {
                    setEditingState(InputIconFieldState.VIEW)
                    dispatch(editLiveDealerLMInfo(originalLMDealerInfo))
                }
        }
    }

    function renderGoogleSpecifics() {
        let info: any = undefined;
        if (editingState === InputIconFieldState.VIEW || editingState === InputIconFieldState.LOADING) {
            if (live) {
                return ( <>
                            <S.Label margin={'17px'}>Call Tracking #</S.Label>
                            <S.ViewLabelNumber margin={'17px'}> {live.trackingNumber??''} </S.ViewLabelNumber> 
                            <S.Label margin={'17px'}>UTM/Tracking Website URL</S.Label>
                            <S.ViewLabelUrl margin={'17px'}>{live.trackingWebsiteUrl??''}</S.ViewLabelUrl>
                        </>)
            }
        } else if (editingState === InputIconFieldState.EDIT && live) {;
            return ( <>
                        <S.Label>Call Tracking #</S.Label>
                        <S.Input
                            value={live.trackingNumber??''}
                            onChange={(e) => onGoogleSpecificsChange('trackingNumber', `${e.target.value}`)}
                        />
                        <S.Label>UTM/Tracking Website URL</S.Label>
                        <S.Input
                        value={live.trackingWebsiteUrl??''}
                        onChange={(e) => onGoogleSpecificsChange('trackingWebsiteUrl', `${e.target.value}`)}
                        />
                    </>);
        }
    }

    function onGoogleSpecificsChange(field: string, value: string) {
        if (field==="trackingNumber")value = value.replace(/[^0-9]/g,'');
        if (live) {
            dispatch(editLiveDealerLMInfo({ ...live, [field]: value ?? "" }))
        }
    }


}

export default GoogleSpecific;